/**
 * This file is meant to host all the functions where there is an interaction with the SessionStorage API of the browser.
 */

/**
 * Clears session storage.
 */
export const clearSessionStorage = (): void => {
  sessionStorage.clear();
};

/**
 * Function to return the user name of the logged in user stored in the session storage.
 * @returns - User Name of the logged in user.
 */
export const getUserNameFromSessionStorage = (): string => {
  return sessionStorage.getItem('user_name') || '';
};

// Every spelling the backend has stored for an admin. Owner and Administrator
// were merged into Admin in Oct 2026; older accounts may still carry the others.
const ADMIN_ROLES = [
  'ROLE_COMPANY_ADMIN',
  'ROLE_OWNER',
  'ROLE_SYSTEM_ADMIN',
  'ROLE_SYS_ADMIN',
  'ROLE_ADMIN'
];

/**
 * Whether the signed-in user is an Admin of their organisation. Only Admins may
 * add, edit or delete users and buy or change the plan. The backend enforces
 * the same rule; this only decides what to show.
 * @param role - Role to test; defaults to the one stored at login.
 * @returns True for any admin role.
 */
export const isAdminRole = (role: string | null = sessionStorage.getItem('role')): boolean =>
  !!role && ADMIN_ROLES.includes(role);

/**
 * Function to return the user name of the logged in user stored in the session storage.
 * @returns - User Name of the logged in user.
 */
export const getTokenFromSessionStorage = (): string => {
  return sessionStorage.getItem('token') || '';
};
